
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.929 14.375H16.07c.71 0 1.286.56 1.286 1.25v2.5c0 .69-.576 1.25-1.286 1.25H1.93c-.711 0-1.286-.56-1.286-1.25v-2.5c0-.69.575-1.25 1.286-1.25zm14.142 0H1.93V11.25c0-3.797 3.166-6.875 7.071-6.875 3.906 0 7.071 3.078 7.071 6.875v3.125zM9 .625c1.065 0 1.929.84 1.929 1.875 0 1.036-.864 1.875-1.929 1.875S7.071 3.535 7.071 2.5C7.071 1.464 7.935.625 9 .625z"}}),_c('path',{attrs:{"d":"M4.5 19.375v-5s0-10 4.5-10m4.5 15v-5s0-10-4.5-10m0 0v15"}})])])
          )
        }
      }
    